import { makeStyles } from "@saleor/macaw-ui";

const useStyles = makeStyles(
  theme => ({
    root: {
      borderRadius: 6,
      background: "white",
      boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.12)",
      overflow: "hidden",
      height: "fit-content"
    },
    header: {
      padding: "1rem 2.4rem",
      background: theme.palette.gardient.medium,
      display: "flex",
      alignItems: "center"
    },
    titleHeader: {
      color: "white"
    },
    customerBox: {
      paddingBottom: "1.6rem"
    },
    title: {
      textTransform: "uppercase",
      color: theme.palette.info.main
    },
    boxInfo: {
      background: "#F2FAFB",
      borderRadius: 4
    },
    infoName: {
      color: theme.palette.info.main
    },
    infoContent: {
      color: theme.palette.grey[900],
      marginLeft: "auto",
      "&.boldWeight": {
        fontWeight: "bold"
      }
    },
    customerInput: {
      paddingTop: "5px",
      marginTop: "10px"
    },
    inputLabel: {
      marginBottom: 10,
      color: theme.palette.grey[900],
      fontSize: 14,
      fontWeight: 700
    },
    required: {
      color: theme.palette.error.main,
      "& :after": {
        content: "*"
      }
    },
    inputField: {
      width: "100%",
      marginBottom: 15,
      "& .MuiOutlinedInput-adornedEnd": {
        paddingRight: "2rem"
      },
      "& [class*=SingleAutocompleteSelectField-adornment]": {
        marginTop: "5px"
      },
      "& .MuiInputBase-input": {
        padding: "12px 16px",
        fontSize: "1.4rem"
      },
      "& .MuiInputBase-input::placeholder": {
        fontSize: "1.4rem",
        color: theme.palette.grey[500]
      },
      "& .MuiSelect-root": {
        padding: "10px 16px"
      },
      "& .MuiFormControl-root": {
        width: "100%"
      }
    },
    customerConfirm: {
      padding: "5px 15px 15px 15px"
    },
    buttonApply: {
      padding: 12,
      width: "100%",
      maxWidth: 92,
      fontSize: 16,
      lineHeight: "24px",
      marginBottom: "15px",
      height: "4.2rem",
      "& .MuiButton-label": {
        fontWeight: 700
      }
    },
    textFieldNoLabel: {},
    footer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      margin: "0 24px",
      padding: "24px 0",
      borderTop: `1px solid ${theme.palette.grey[400]}`
    },
    shippingAddress: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    },
    wrapContent: {
      padding: 24
    },
    wrapInfoMore: {
      padding: "12px 0 12px 16px ",
      borderRadius: 6
    },
    titleInfoMore: {
      marginBottom: 16,
      color: theme.palette.grey[900]
    },
    selectField: {
      "& .MuiSelect-root": {
        color: theme.palette.grey[900],
        fontSize: "1.4rem"
      }
    },
    labelAddress: {
      color: theme.palette.grey[900]
    },
    btnAddress: {
      fontSize: "1.4rem"
    },
    titleTextArea: {
      display: "flex",
      alignItems: "center",
      columnGap: "8px"
    },
    subTitleTextArea: {
      color: theme.palette.info.dark
    },
    selectItem: {
      fontWeight: "bold",
      display: "inline-block",
      marginRight: 5
    },
    company: {
      color: theme.palette.info.dark,
      padding: "1.6rem 1.2rem"
    },
    project: {
      padding: "0.8rem 1.6rem",
      marginTop: "0.8rem"
    },
    submitForm: {
      display: "flex",
      alignItems: "center",
      columnGap: "8px"
    },
    flexItemTop: {
      alignItems: "start"
    },
    customTextbox: {
      marginBottom: 0
    },
    paymentTerms: {
      height: "4.0rem",
      display: "flex",
      alignItems: "center"
    },
    textError: {
      color: theme.palette.error.light,
      marginTop: 5
    }
  }),
  { name: "CustomerDataInfo" }
);

export default useStyles;
